<article class="d-flex justify-content-center w-100 bg-black p-2 hide-on-mobile">
  <div class="text-white ms-2 me-5 container-filtro">
    <div style="display: flex;">
      <label class="me-2" for="data">Data visualização:</label>
      <input id="data" class="data-datepicker" type="date" [(ngModel)]="dashboardService.dataVisualizacao" (ngModelChange)="dataChange()">
    </div>
  
    <div class="d-flex ms-1">
      <div class="form-check form-switch custom-switch"  title="Roteiros do dia.">
        <input
          type="checkbox"
          class="form-check-input"
          id="switchRoteirosDia"
          [checked]="checked"
          (change)="checkboxChange($event.target.checked)"
        />
        <label
          style="color: white"
          class="form-check-label"
          for="switchRoteirosDia">
        </label>
      </div>
      <span class="fonte-span ms-1">Ver também roteiros com mov. no dia</span>
    </div>
  </div>

  <div class="text-white me-4 pe-4 d-flex flex-column justify-content-center" >
    <p>Clientes</p>
    <p class="font-clientes">{{ totalClientes }}</p>
  </div>

  <div class="d-flex">    
    <app-card-info-entregas titulo="Atendidos" [quantidade]="totalClientesAtendidos"  icone="atendidas"></app-card-info-entregas> 
    <app-card-info-entregas titulo="Não atendidos" [quantidade]="totalClientesNaoAtendidos"  icone="nao_atendidas"></app-card-info-entregas> 
    <app-card-info-entregas titulo="Em análise" [quantidade]="totalClientesAnalise"  icone="em_analise"></app-card-info-entregas> 
    <app-card-info-entregas titulo="Pendentes" [quantidade]="totalClientesNaoVisitados"  icone="pendentes"></app-card-info-entregas> 
  </div>
</article>

<div class="mobile-totalizadores-container hide-on-desktop">
  <div class="mobile-totalizadores-grid">
    <div class="mobile-card-totalizador">
      <div class="card-icon-container">
        <img src="assets/img/entregas_atendidas.svg" alt="Atendidos">
      </div>
      <div class="card-text-container">
        <span class="card-label">Atendidos</span>
        <span class="card-value">{{ totalClientesAtendidos }}</span>
      </div>
    </div>

    <div class="mobile-card-totalizador">
      <div class="card-icon-container">
        <img src="assets/img/entregas_nao_atendidas.svg" alt="Não atendidos">
      </div>
      <div class="card-text-container">
        <span class="card-label">Não atendidos</span>
        <span class="card-value">{{ totalClientesNaoAtendidos }}</span>
      </div>
    </div>

    <div class="mobile-card-totalizador">
      <div class="card-icon-container">
        <img src="assets/img/entregas_em_analise.svg" alt="Em análise">
      </div>
      <div class="card-text-container">
        <span class="card-label">Em análise</span>
        <span class="card-value">{{ totalClientesAnalise }}</span>
      </div>
    </div>

    <div class="mobile-card-totalizador">
      <div class="card-icon-container">
        <img src="assets/img/entregas_pendentes.svg" alt="Pendentes">
      </div>
      <div class="card-text-container">
        <span class="card-label">Pendentes</span>
        <span class="card-value">{{ totalClientesNaoVisitados }}</span>
      </div>
    </div>
  </div>
</div> 